const _updateStateHelper = (htmlElement, state, action) => {
    if(action == 'add') {
        if(Array.isArray(state)) {
            state.forEach((s) => {
                htmlElement.classList.add(s);
            });
        } else {    
            htmlElement.classList.add(state);
        }
    } else if (action == 'remove') {
        if(Array.isArray(state)) {
            state.forEach((s) => {
                htmlElement.classList.remove(s);
            });
        } else {    
            htmlElement.classList.remove(state);
        }
    }
}

const helpPageBuilder = () => {

    let htmlElements = {};

    const getHtmlElements = () => {
        htmlElements.anchors_section = document.querySelector('.shopify-section--multi-column');
        htmlElements.faq_sections = document.querySelectorAll('.shopify-section--faq');
    }

    const showFirstFAQSection = () => {
        _updateStateHelper(htmlElements.anchors_section.querySelectorAll('.multi-column__item')[0], 'active', 'add');
        htmlElements.faq_sections[0].querySelector('.section').style.display = 'block';
    }

    const removeActiveLinks = () => {
        htmlElements.anchors_section.querySelectorAll('.multi-column__item.active').forEach((active_anchor) => {
            _updateStateHelper(active_anchor, 'active', 'remove');
        });
    }

    const setCurrentLinkActive = (event) => {
        _updateStateHelper(event.currentTarget, 'active', 'add');
    }

    const hideAllFAQsection = () => {
        htmlElements.faq_sections.forEach((faq_section) => {
            faq_section.querySelector('.section').style.display = 'none';
        });
    }

    const showActiveFAQsection = (event) => {
        document.querySelector(event.currentTarget.querySelector('.multi-column__link').hash).style.display = 'block';
    }

    const helpPageToggler = (event) => {
      event.preventDefault();
      if(!event.currentTarget.classList.contains('active')) {
        removeActiveLinks();
        setCurrentLinkActive(event);
        hideAllFAQsection();
        showActiveFAQsection(event);
      }
    }

    const assignEvents = () => {
        htmlElements.anchors_section.querySelectorAll('.multi-column__item').forEach((anchor) => {
            anchor.addEventListener('click', helpPageToggler);
        });
    }

    getHtmlElements();
    showFirstFAQSection();
    assignEvents();
    
  }

  const helpPageSearchBuilder = () => {

    let htmlElements = {};

    const getHtmlElements = () => {
        htmlElements.main_content = document.getElementById('main');
        htmlElements.tabs_section = document.querySelector('.shopify-section--multi-column');
        htmlElements.faq_search = document.querySelector('#faq-search');
        htmlElements.faq_search_submit = document.querySelector('.faq-search-submit');
        htmlElements.faq_search_clear = document.querySelector('.faq-search-clear');
        htmlElements.all_faq = document.querySelectorAll('.shopify-section--faq');
        htmlElements.all_faq_node = document.createElement('div');
    }

    const buildAllFAQsection = () => {
        htmlElements.all_faq.forEach((faq_section, indexP) => {
            let faq_node = faq_section.querySelector('.faq');
            let clone_faq_node = faq_node.cloneNode(true);
            clone_faq_node.querySelectorAll('.faq__item').forEach((faq_item, indexC) => {
                let new_id = `faqsearch-${indexP}-${indexC}`;
                faq_item.querySelector('button').setAttribute('aria-controls',new_id);
                faq_item.querySelector('.collapsible').setAttribute('id',new_id);
            });
            htmlElements.all_faq_node.appendChild(clone_faq_node);
        });
        let states = ['shopify-section','shopify-section--faq','search-faq-all-results'];
        _updateStateHelper(htmlElements.all_faq_node, states, 'add');
        htmlElements.all_faq_node.style.display = 'none';
        htmlElements.tabs_section.after(htmlElements.all_faq_node);
    }

    const clearFAQResults = () => {
        htmlElements.faq_search.value = '';
        htmlElements.faq_search.dispatchEvent(new Event('change'));
        _updateStateHelper(htmlElements.main_content, 'search-results-active', 'remove');
        _updateStateHelper(htmlElements.main_content, 'search-results-empty', 'remove');
        htmlElements.all_faq_node.style.display = 'none';
    }

    const showFAQResults = () => {
        let finds_counter = 0;
        if(htmlElements.all_faq_node.querySelector('.is-first')) {
            _updateStateHelper(htmlElements.all_faq_node.querySelector('.is-first'), 'is-first', 'remove');
        }
        htmlElements.all_faq_node.querySelectorAll('.faq__item').forEach((faq_node_item) => {
          if(faq_node_item.querySelector('.faq-question').textContent.toLowerCase().search(htmlElements.faq_search.value.toLowerCase()) >= 0 || 
          faq_node_item.querySelector('.text-container').textContent.toLowerCase().search(htmlElements.faq_search.value.toLowerCase()) >= 0) {
            faq_node_item.style.display = 'block';
            if(finds_counter == 0) {
                _updateStateHelper(faq_node_item,'is-first','add');
            }
            finds_counter++;
          } else {
            faq_node_item.style.display = 'none';
          }
        });
        _updateStateHelper(htmlElements.main_content, 'search-results-active', 'add');
        htmlElements.all_faq_node.style.display = 'block';
        if(finds_counter == 0) {
            _updateStateHelper(htmlElements.main_content, 'search-results-empty', 'add');
        } else {
            _updateStateHelper(htmlElements.main_content, 'search-results-empty', 'remove');
        }
    }

    const findFAQResults = () => {
      if(htmlElements.faq_search.value.trim() == '') {
        clearFAQResults();
      } else {
        showFAQResults();
      }
    }

    const assignEvents = () => {
        htmlElements.faq_search.addEventListener('keyup', findFAQResults);
        htmlElements.faq_search_submit.addEventListener('click', findFAQResults);
        htmlElements.faq_search_clear.addEventListener('click', clearFAQResults);
    }

    getHtmlElements();
    buildAllFAQsection();
    assignEvents();
  }
  
  window.onload = (event) => {
    const is_help_page = document.location.pathname == '/pages/help' || document.location.pathname == '/pages/hcp-faqs' ? true : false;
    if(is_help_page === true) { 
      helpPageBuilder();
      helpPageSearchBuilder();
    }  
  };